import { render, staticRenderFns } from "./dataSummaryyw.vue?vue&type=template&id=991af288&scoped=true&"
import script from "./dataSummaryyw.vue?vue&type=script&lang=js&"
export * from "./dataSummaryyw.vue?vue&type=script&lang=js&"
import style0 from "./dataSummaryyw.vue?vue&type=style&index=0&id=991af288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991af288",
  null
  
)

export default component.exports